import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { openWhatsApp, createCartWhatsAppMessage } from "../utils/whatsapp";
import "./Cart.css";

const Cart = () => {
  const {
    cartItems,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
    clearCart,
    getCartTotal,
  } = useContext(CartContext);

  const total = getCartTotal();

  if (cartItems.length === 0) {
    return (
      <main className="cart-page">
        <section className="cart-header">
          <p>STAR GOLD</p>
          <h1>Shopping Cart</h1>
        </section>

        <section className="cart-empty">
          <div className="cart-empty-icon">🛒</div>

          <h2>Your cart is empty</h2>

          <p>
            Discover our jewellery collection and add something beautiful to
            your cart.
          </p>

          <Link to="/collections" className="cart-shop-button">
            Continue Shopping
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="cart-page">
      {/* HEADER */}

      <section className="cart-header">
        <p>STAR GOLD</p>
        <h1>Shopping Cart</h1>

        <span>
          {cartItems.length} {cartItems.length === 1 ? "item" : "items"}
        </span>
      </section>

      {/* CART CONTENT */}

      <section className="cart-content">
        <div className="cart-items-section">
          {cartItems.map((item) => (
            <article className="cart-item" key={item.id}>
              {/* IMAGE */}

              <div className="cart-item-image">
                <Link to={`/product/${item.id}`}>
                  <img src={item.imageUrl} alt={item.name} />
                </Link>
              </div>

              {/* DETAILS */}

              <div className="cart-item-details">
                <p className="cart-item-category">{item.category}</p>

                <h2>
                  <Link to={`/product/${item.id}`}>{item.name}</Link>
                </h2>

                <p className="cart-item-price">
                  ₹{Number(item.salePrice ?? item.price)}
                </p>

                {/* QUANTITY */}

                <div className="cart-quantity">
                  <button
                    type="button"
                    onClick={() => decreaseQuantity(item.id)}
                  >
                    −
                  </button>

                  <span>{item.quantity}</span>

                  <button
                    type="button"
                    onClick={() => increaseQuantity(item.id)}
                  >
                    +
                  </button>
                </div>
              </div>

              {/* ITEM TOTAL + REMOVE */}

              <div className="cart-item-actions">
                <p className="cart-item-total">
                  ₹{Number(item.salePrice ?? item.price) * item.quantity}
                </p>

                <button
                  type="button"
                  className="cart-remove-button"
                  onClick={() => removeFromCart(item.id)}
                >
                  Remove
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* SUMMARY */}

        <aside className="cart-summary">
          <p className="cart-summary-label">ORDER SUMMARY</p>

          <h2>Cart Total</h2>

          <div className="cart-summary-line"></div>

          <div className="cart-total-row">
            <span>Total</span>
            <strong>₹{total}</strong>
          </div>

          <Link to="/checkout" className="cart-checkout-button">
            Proceed to Checkout
          </Link>

          <button
            type="button"
            className="cart-clear-button"
            onClick={clearCart}
          >
            Clear Cart
          </button>
          <button
            type="button"
            className="cart-whatsapp-button"
            onClick={() =>
              openWhatsApp(createCartWhatsAppMessage(cartItems, getCartTotal()))
            }
          >
            Order via WhatsApp
          </button>

          <Link to="/collections" className="cart-continue-link">
            ← Continue Shopping
          </Link>
        </aside>
      </section>
    </main>
  );
};

export default Cart;
